import React from 'react';
import { Link } from 'react-router-dom';

const Products: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary-50 to-secondary-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">Our Products</h1>
            <p className="max-w-3xl mx-auto mt-5 text-xl text-gray-600">
              Advanced robotic solutions designed to keep your solar panels operating at peak efficiency.
            </p>
          </div>
        </div>
      </section>

      {/* Product Lineup */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Solar Panel Cleaning Robots</h2>
            <p className="mt-4 text-xl text-gray-600">
              Choose the perfect solution for your solar installation needs.
            </p>
          </div>

          {/* Automated Model */}
          <div className="mb-24">
            <div className="lg:flex items-center">
              <div className="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
                <img 
                  src="/product1.png" 
                  alt="RoboTronics V2.0 (AI-Assisted)"
                  className="rounded-lg shadow-xl"
                />
              </div>
              <div className="lg:w-1/2 lg:pl-10">
                <div className="inline-block px-3 py-1 mb-3 text-xs font-semibold uppercase tracking-wider text-accent-dark bg-accent-50 rounded-full">In Development — Launching Soon</div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">RoboTronics V2.0 (AI-Assisted)</h3>
                <p className="text-gray-600 mb-6">
                  Our next-generation robot combines AI-assisted automated cleaning with a rugged, waterproof design optimized specifically for desert and harsh environmental conditions.
                </p>
                
                <div className="bg-gray-50 p-6 rounded-lg mb-6">
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Key Features</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>AI-assisted automated cleaning for greater efficiency and accuracy</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Enhanced safety system to prevent panel damage and operator hazards</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Rugged, waterproof design optimized for desert environments</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Improved remote control system with greater operational range</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>User-friendly functionality with minimal training required</span>
                    </li>
                  </ul>
                </div>
                
                <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                  <Link
                    to="/contact"
                    className="px-6 py-3 text-base font-medium text-white bg-primary rounded-md shadow hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  >
                    Request Quote
                  </Link>
                  <button
                    className="px-6 py-3 text-base font-medium text-primary bg-white border border-primary rounded-md shadow hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  >
                    Download Specs
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Remote-Controlled Model */}
          <div>
            <div className="lg:flex items-center flex-row-reverse">
              <div className="lg:w-1/2 mb-10 lg:mb-0 lg:pl-10">
                <img 
                  src="/product2.png" 
                  alt="Remote-Controlled Model" 
                  className="rounded-lg shadow-xl"
                />
              </div>
              <div className="lg:w-1/2 lg:pr-10">
                <div className="inline-block px-3 py-1 mb-3 text-xs font-semibold uppercase tracking-wider text-secondary-dark bg-secondary-50 rounded-full">Available Now</div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">Remote-Controlled Model</h3>
                <p className="text-gray-600 mb-6">
                  Our field-proven, cost-effective robot delivers water-efficient cleaning with simple remote control — tailored for commercial and industrial solar installations in regional climatic conditions.
                </p>
                <p className="text-lg font-semibold text-primary mb-6">From $5,000 per unit — Cleaning-as-a-Service and annual maintenance packages available.</p>
                
                <div className="bg-gray-50 p-6 rounded-lg mb-6">
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Key Features</h4>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Edge-detection safety system for safe operation on arrays</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Rugged, weather-resistant design for harsh desert environments</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Simple, user-friendly remote control — minimal training required</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Water-efficient cleaning that protects scarce resources</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-primary mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Field-proven at the Hesia Industrial Zone — 500+ panels cleaned</span>
                    </li>
                  </ul>
                </div>
                
                <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                  <Link
                    to="/contact"
                    className="px-6 py-3 text-base font-medium text-white bg-primary rounded-md shadow hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  >
                    Request Quote
                  </Link>
                  <button
                    className="px-6 py-3 text-base font-medium text-primary bg-white border border-primary rounded-md shadow hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                  >
                    Download Specs
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Personal Solar Panel Cleaning System */}
      <section className="py-16 bg-gradient-to-r from-primary-50 to-secondary-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:flex items-stretch bg-white rounded-lg shadow-md overflow-hidden">
            <div className="lg:w-1/3 bg-gradient-to-br from-primary to-industrial p-12 flex items-center justify-center">
              <img src="/logo-white.png" alt="RoboTronics Personal Solar Panel Cleaning System" className="w-40 h-40 opacity-90" />
            </div>
            <div className="lg:w-2/3 p-8 lg:p-12">
              <div className="inline-block px-3 py-1 mb-3 text-xs font-semibold uppercase tracking-wider text-accent-dark bg-accent-50 rounded-full">New Product Line — Coming Soon</div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Personal Solar Panel Cleaning System</h3>
              <p className="text-gray-600 mb-4">
                A compact, affordable, and efficient cleaning solution designed specifically for residential solar installations. Built for ease of use and high reliability, with competitive pricing for the fast-growing home solar market.
              </p>
              <p className="text-gray-600 mb-6">
                Launching first in the local market, with regional expansion to follow.
              </p>
              <Link
                to="/contact"
                className="inline-block px-6 py-3 text-base font-medium text-white bg-accent rounded-md shadow hover:bg-accent-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent"
              >
                Register Your Interest
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Common Features */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Common Features</h2>
            <p className="mt-4 text-xl text-gray-600">
              All Robotronics cleaning robots include these essential features.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-primary mb-4">
                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Waterproof Design</h3>
              <p className="text-gray-600">
                Fully waterproof construction allows operation in all weather conditions without damage to internal components.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-primary mb-4">
                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Rugged Construction</h3>
              <p className="text-gray-600">
                Durable materials and reinforced design ensure longevity even in harsh environmental conditions.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-primary mb-4">
                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">IR Sensors</h3>
              <p className="text-gray-600">
                Infrared sensors detect obstacles and panel edges to prevent damage and ensure complete coverage.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="text-primary mb-4">
                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Battery Monitoring</h3>
              <p className="text-gray-600">
                Advanced battery management system with real-time monitoring and automatic low-power return functionality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Product Comparison</h2>
            <p className="mt-4 text-xl text-gray-600">
              Find the right solution for your needs.
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Feature
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    RoboTronics V2.0
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Remote-Controlled Model
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Navigation
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    AI-assisted automated cleaning
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Remote control with edge detection
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Water Recycling
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    90% efficiency
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    70% efficiency
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Battery Life
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    8 hours
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    6 hours
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Cleaning Speed
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    100 m²/hour
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    80 m²/hour
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Waterproof Rating
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    IP67
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    IP65
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Remote Monitoring
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Yes, with performance analytics
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Basic monitoring
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Ideal For
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Commercial & industrial installations
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Homes, small commercial & pilot deployments
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Availability
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    In development — launching soon
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Available now
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Price
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Contact us for a quote
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    From $5,000 per unit
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Services & Business Model */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Beyond the Robot</h2>
            <p className="mt-4 text-xl text-gray-600">
              Flexible ways to work with RoboTronics.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm border-t-4 border-primary">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Cleaning-as-a-Service</h3>
              <p className="text-gray-600">
                Scheduled robotic cleaning for industrial and commercial solar farms — keep panels at peak performance without owning the hardware.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border-t-4 border-secondary">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Annual Maintenance Packages</h3>
              <p className="text-gray-600">
                Comprehensive servicing, updates, and priority technical support to keep your robots operating at their best.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border-t-4 border-accent">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Customized Hardware Solutions</h3>
              <p className="text-gray-600">
                Tailored robotic cleaning hardware engineered for your site's specific panels, layout, and environment.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl mb-6">
            Ready to boost your solar panel efficiency?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
            Contact our team today for a personalized quote and product demonstration.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-3 text-base font-medium text-primary bg-white rounded-md shadow hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Products;
